import store from '@/store';
import router from '@/router';
import routes from './route';
import {advert} from '@/modules/display/store/advert';
import {logs} from '@/modules/display/store/logs';
import {elevator} from '@/modules/display/store/elevator';
import {elevatorForm} from '@/modules/display/store/elevator-form';
import layout from '@/modules/display/store/layout';
import {routes as storeRoutes} from '@/modules/display/store/routes';
const MODULE_NAME = 'display'
const TRANSLATION_PREFIX = 'display/'

//installs module
export default class DisplayModule {

  static uninstall() {
    store.unregisterModule(MODULE_NAME);
  }

  static install() {

    //add the module stores
    //by making preserveState dependant on the current state, we can add new state if missing or retain state if existing
    store.registerModule(MODULE_NAME, {namespaced: true});

    store.registerModule([MODULE_NAME, 'advert'], advert);
    store.registerModule([MODULE_NAME, 'layout'], layout);
    store.registerModule([MODULE_NAME, 'routes'], storeRoutes);
    /* @todo check this store, it could be happened that we don't use this store anymore */
    store.registerModule([MODULE_NAME, 'elevator'], elevator);
    store.registerModule([MODULE_NAME, 'elevatorForm'], elevatorForm);
    store.registerModule([MODULE_NAME, 'logs'], logs);

    let enMap = new Map();
    enMap.set(TRANSLATION_PREFIX + 'dashboard', () => import('@/modules/display/translations/en/dashboard.json'));
    enMap.set(TRANSLATION_PREFIX + 'advert', () => import('@/modules/display/translations/en/advert.json'));
    enMap.set(TRANSLATION_PREFIX + 'navbar', () => import('@/modules/display/translations/en/navbar.json'));
    enMap.set(TRANSLATION_PREFIX + 'elevator', () => import('@/modules/display/translations/en/elevator.json'));
    enMap.set(TRANSLATION_PREFIX + 'offer', () => import('@/modules/display/translations/en/offer.json'));
    enMap.set(TRANSLATION_PREFIX + 'pdf', () => import('@/modules/display/translations/en/pdf.json'));
    enMap.set(TRANSLATION_PREFIX + 'editor', () => import('@/modules/display/translations/en/editor.json'));
    enMap.set(TRANSLATION_PREFIX + 'logs', () => import('@/modules/display/translations/en/logs.json'));
    enMap.set(TRANSLATION_PREFIX + 'emergency', () => import('@/modules/display/translations/en/emergency.json'));
    enMap.set(TRANSLATION_PREFIX + 'certificate', () => import('@/modules/display/translations/en/certificate.json'));
    enMap.set(TRANSLATION_PREFIX + 'dashboard', () => import('@/modules/display/translations/en/dashboard.json'));

    let deMap = new Map();
    deMap.set(TRANSLATION_PREFIX + 'dashboard', () => import('@/modules/display/translations/de/dashboard.json'));
    deMap.set(TRANSLATION_PREFIX + 'advert', () => import('@/modules/display/translations/de/advert.json'));
    deMap.set(TRANSLATION_PREFIX + 'navbar', () => import('@/modules/display/translations/de/navbar.json'));
    deMap.set(TRANSLATION_PREFIX + 'elevator', () => import('@/modules/display/translations/de/elevator.json'));
    deMap.set(TRANSLATION_PREFIX + 'offer', () => import('@/modules/display/translations/de/offer.json'));
    deMap.set(TRANSLATION_PREFIX + 'pdf', () => import('@/modules/display/translations/de/pdf.json'));
    deMap.set(TRANSLATION_PREFIX + 'editor', () => import('@/modules/display/translations/de/editor.json'));
    deMap.set(TRANSLATION_PREFIX + 'logs', () => import('@/modules/display/translations/de/logs.json'));
    deMap.set(TRANSLATION_PREFIX + 'emergency', () => import('@/modules/display/translations/de/emergency.json'));
    deMap.set(TRANSLATION_PREFIX + 'certificate', () => import('@/modules/display/translations/de/certificate.json'));
    deMap.set(TRANSLATION_PREFIX + 'dashboard', () => import('@/modules/display/translations/de/dashboard.json'));

    let translationMap = new Map();
    translationMap.set('en', enMap);
    translationMap.set('de', deMap);

    store.commit('translation/updateImportMap', translationMap);
    this.installNameSpace();
  }

  static installNameSpace() {
    //namespace that is used for all or most components
    let globalNamespace = ['display/navbar'];

    let namespaces = globalNamespace;
    if(store.state.translation.namespaces) {
      namespaces = namespaces.concat(store.state.translation.namespaces);
    }

    store.commit("translation/updateNamespaces", namespaces);
    store.commit("translation/loadNamespaces");
  }

  static installRoutes() {
    routes.forEach(function(route){
      router.addRoute(route);
    });
  }
}
